import ProvisionReport from './ProvisionReport';

export default ProvisionReport;